import {createAction} from 'redux-act'

export const setPaymentModalVisible = createAction('SET_PAYMENT_MODAL_VISIBLE')
export const setPaymentForm = createAction('SET_PAYMENT_FORM')



